import Vue from 'vue';
import axios from 'axios';
import Promise from 'promise-polyfill';

import IEPolyfills from './quiz-campaign/ie-polyfills';

import Landing from './quiz-campaign/components/landing';
import Questions from "./quiz-campaign/components/questions";
import PagedQuestions from "./quiz-campaign/components/paged-questions";
import LoadingScreen from "./quiz-campaign/components/loading-screen";
import EndpointPage from './quiz-campaign/components/endpoint-page';

window.Vue = Vue;
window.axios = axios;

window.Event = new Vue();

new Vue({
	el: "#quiz-campaign",
	components: {
		Landing,
		Questions,
		PagedQuestions,
		LoadingScreen,
		EndpointPage
	}
});


// WEBPACK FOOTER //
// ./resources/assets/js/quiz-campaign.js